import { CourseAssignee } from './getCourseAssignees';
import { CommonRequestOptions, makeRequest } from '../makeRequest';

export type CourseTeamMemberAssigneesResponse = {
   hasMore: boolean;
   response: Array<CourseAssignee>;
};

export type GetCourseTeamMemberAssigneesOptions = CommonRequestOptions & {
   page?: number;
   limit?: number;
};

export async function getCourseTeamMemberAssignees(
   wikiid: number,
   teamid: number,
   options: GetCourseTeamMemberAssigneesOptions = {}
): Promise<CourseTeamMemberAssigneesResponse> {
   const { page, limit, ...common } = options;

   let queryParams = `page=${page}&limit=${limit}`;

   return await makeRequest(
      'get',
      `course_assignees/course/${wikiid}/teams/${teamid}?${queryParams}`,
      {
         ...common,
      }
   );
}
